import React       from 'react'
import PropTypes   from 'prop-types'
import { connect } from 'react-redux'

import ActionButton from '../components/ActionButton'

import { setFilter } from '../redux/actions/items'
import api from '../redux/api'

class DeleteMaintenanceButton extends React.Component {
  static propTypes = {
    // Props coming from parent
    maintenance:    PropTypes.object.isRequired,
    // Props coming from Redux
    filterCriteria: PropTypes.object.isRequired,
    setFilter:      PropTypes.func.isRequired,
  }

  state = {
    modalOpen: false,
  }

  handleDelete = () => {
    return api.deleteMaintenance({ id: this.props.maintenance.id })
  }

  handleDeleteComplete = () => {
    this.setState({ modalOpen: true }, () => {
      this.props.setFilter(this.props.filterCriteria)
    })
  }

  render() {
    const { maintenance } = this.props

    const message = `Are you you want to delete "${maintenance.name}" maintenance?`

    return (
      <ActionButton
        buttonColor={"#e33a30c4"}
        buttonIconName="times circle"
        buttonText="Delete Maintenance"
        onPerformAction={this.handleDelete}
        onPerformActionComplete={this.handleDeleteComplete}
        confirmationTitle={message}
        confirmationHeader="Delete Maintenance Template"
      />
    )
  }
}

const mapDispatchToProps = {
  setFilter,
}
const mapStateToProps = (state) => ({
  filterCriteria: state.items.filterCriteria,
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteMaintenanceButton)
